import Popper from 'popper.js'
import $ from 'jquery'
import './popper.css'
import './index.css'
export default class WeaDriver {
  constructor(steps) {
    this.steps = steps;
    this.current = 0;
  }
  /**
   * 公有方法-初始化
   */
  init() {
    this._renderDriver();
    this._drawDriver();
    this._bindEvent();
  }
  /**
   * 公有方法-执行下一个
   */
  next() {
    if(this.current != this.steps.length - 1) {
      this.current = this.current + 1;
      this._drawDriver();
    } else {
      this.reset();
    }
  }
  /**
   * 公有方法-执行上一个
   */
  prev() {
    if(this.current != 0) {
      this.current = this.current - 1;
      this._drawDriver();
    }else{
      this.reset();
    }
  }
  /**
   * 公有方法-重置队列
   */
  reset(steps) {
    this.current = 0;
    steps ? this.steps = steps : '';
    $('#wea_dirver').fadeOut();
  }
  /**
   * 公有方法-开始引导
   */
  start() {
    this._drawDriver();
    $('#wea_dirver').fadeIn();
  }
  /**
   * 私有方法-重绘弹出层
   */
  _drawDriver() {
    this._setStepLayer();
    this._setStepPopper();
    this._setStepInfo();
  }
  /**
   * 私有方法-获取当前步骤的位置信息，并创建遮罩图层
   */
  _setStepLayer() {
    const stepID = this.steps[this.current].element;
    const layer_west = {
      top: 0,
      left: 0,
      width: $(stepID).offset().left,
      height: $(document).height(),
    };
    const layer_east = {
      top: 0,
      right: 0,
      width: $(document).width() - $(stepID).offset().left - $(stepID).width(),
      height: $(document).height()
    }
    const layer_north = {
      top: 0,
      left: $(stepID).offset().left,
      width: $(stepID).width(),
      height: $(stepID).offset().top,
    };
    const layer_south = {
      top: $(stepID).offset().top + $(stepID).height(),
      left: $(stepID).offset().left,
      width: $(stepID).width(),
      height: $(document).height() - $(stepID).offset().top - $(stepID).height(),
    };
    $('#wea_driver_layer_west').css(layer_west);
    $('#wea_driver_layer_east').css(layer_east);
    $('#wea_driver_layer_north').css(layer_north);
    $('#wea_driver_layer_south').css(layer_south);
  }
  /**
   * 私有方法-设置弹出层样式
   */
  _setStepPopper() {
    const stepID = this.steps[this.current].element;
    const position = this.steps[this.current].popover.position;
    const reference = document.querySelector(stepID);
    const popper = document.querySelector('#wea_driver_popper');
    new Popper(reference, popper, {
      placement: position,
      modifiers: {
        preventOverflow: {
          escapeWithReference: true
        }
      }
    });
  }
  /**
   * 私有方法-设置当前步骤信息
   */
  _setStepInfo() {
    const { title, description } = this.steps[this.current].popover;
    $('.wea-driver-popper-title').html(title);
    $('.wea-driver-popper-description').html(description);
  }
  /**
   * 私有方法-渲染引导组件图层
   */
  _renderDriver() {
    $('body').append(`
      <div id="wea_dirver" class="wea-driver">
        <div id="wea_driver_layer" class="wea-driver-layer">
          <div id="wea_driver_layer_west" class="wea-driver-layer-block"></div>
          <div id="wea_driver_layer_east" class="wea-driver-layer-block"></div>
          <div id="wea_driver_layer_north" class="wea-driver-layer-block"></div>
          <div id="wea_driver_layer_south" class="wea-driver-layer-block"></div>
        </div>
        <div id="wea_driver_popper" class="popper wea-driver-popper">
          <h2 class="wea-driver-popper-title">主标题</h2>
          <p class="wea-driver-popper-description">副标题</p>
          <div class="wea-driver-popper-btns">
            <div class="wea-driver-popper-btn wea-driver-popper-cancel">知道了</div>
            <div class="wea-driver-popper-btn wea-driver-popper-prev">上一步</div>
            <div class="wea-driver-popper-btn wea-driver-popper-next">下一步</div>
          </div>
          <div class="popper__arrow wea-driver-popper-arrow" x-arrow></div>
        </div>
      </div>
    `)
  }
  /**
   * 私有方法-绑定事件
   */
  _bindEvent() {
    $('.wea-driver-popper-next').on('click', () => {
      const handle_next = this.steps[this.current].onNext;
      if(handle_next != undefined) {
        handle_next().then(() => {
          // 跳到下一步
          this.next();
        });
      } else {
        // 跳到下一步
        this.next();
      }
    });
    $('.wea-driver-popper-prev').on('click', () => {
      const handle_prev = this.steps[this.current].onPrevious;
      if(handle_prev != undefined) {
        handle_prev().then(() => {
          // 跳到上一步
          this.prev();
        });
      } else {
        // 跳到上一步
        this.prev();
      }
    });
    $('.wea-driver-popper-cancel').on('click', () => this.reset());
  }
}